import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS_TIPOS_DOCUMENTO } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminTiposDocumentoPage } from "@/features/admin-tipos-documento/components/AdminTiposDocumentoPage";
import { tiposDocumentoAdminQueryOptions } from "@/features/admin-tipos-documento/hooks/use-tipos-documento-admin";

/** Ruta `/admin/tipos-documento` · CRUD del catálogo de tipos de documento adicional (P31). */
export const Route = createFileRoute("/_authed-tw/admin/tipos-documento")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion(PERMISOS_TIPOS_DOCUMENTO)
      ? queryClient.ensureQueryData(tiposDocumentoAdminQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={PERMISOS_TIPOS_DOCUMENTO}>
      <AdminTiposDocumentoPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
